export function encodeCaseName(caseName: string) {
  return caseName.replace(/\s/g, '-')
}

export function decodeCaseName(uri: string) {
  return uri.replace(/-/g, ' ')
}
